import { RootState } from '../redux';

export const selectUseMockResponseState = (state: RootState) => state.suggestions.flags.useMockResponse;